"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Coins, Zap, Handshake } from "lucide-react";
const features = [{
  title: "Transparente Festpreise",
  description: "Schluss mit 5.000 CHF Rechnungen. Wir bieten professionelle Webseiten ab 990 CHF – fix, fair und ohne versteckte Kosten für Ihr Unternehmen."
}, {
  title: "Express Lieferung",
  description: "Ihre Konkurrenz schläft nicht. Wir bringen Ihre neue Webseite in 7 bis 14 Tagen live, damit Sie sofort online sichtbar sind und Kunden gewinnen."
}, {
  title: "Partner-Erfolg",
  description: "Wir begleiten Sie als langfristiger Partner. Ihr Erfolg ist unser Antrieb – mit persönlicher Beratung und massgeschneiderten Lösungen für Schweizer KMU."
}];
const icons = [Coins, Zap, Handshake];
export default function OurCoreCompetencies() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="73629" id="ihre-lösung-für-online-erfolg" className="relative z-20 w-full bg-muted text-foreground py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-[36px] font-bold text-[#0A1628] leading-tight">
            Was uns von anderen Agenturen unterscheidet
          </h2>
          <p className="text-[#6B7280] mt-4 text-lg">
            Drei Versprechen, die wir jeden Tag einhalten.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 pb-20 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => {
          const Icon = icons[i];
          return <div key={i} data-index={i} className="h-full">
                <Card className="h-full flex flex-col bg-white border border-[#E5E7EB] rounded-2xl shadow-sm hover:-translate-y-2.5 hover:shadow-md transition-all duration-300">
                  <CardHeader className="pb-2">
                    <div className="w-12 h-12 bg-[#EEF2FF] rounded-[12px] flex items-center justify-center mb-4 shrink-0">
                      <Icon className="w-6 h-6 text-[#4F46E5]" />
                    </div>
                    <CardTitle className="text-xl font-default font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex flex-col flex-grow pt-2">
                    <p className="text-base font-default leading-relaxed text-muted-foreground flex-grow">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}